import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import App from './App';
import reportWebVitals from './reportWebVitals';
import configureStore, { history } from 'store/store';
import appConfig from 'constants/appConfig';
import { loadLocale } from 'utils';
import { IntlProvider } from 'react-intl';
import { initializePhraseAppEditor } from 'react-intl-phraseapp';
import 'styles/index.scss';

const store = configureStore();

const config = {
  projectId: appConfig.phraseProjectId,
  phraseEnabled: appConfig.isPhraseEnabled,
  autoLowercase: false,
  prefix: '[[__',
  suffix: '__]]',
  fullReparse: true,
};

initializePhraseAppEditor(config);

async function bootstrapApplication(): Promise<any> {
  // const locale = navigator.language.slice(0, 2);
  const locale = 'en'; // hardcoded until we have different languages
  const localeMessages = await loadLocale(locale);

  ReactDOM.render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <IntlProvider locale={locale} messages={localeMessages} defaultLocale='en'>
          <App />
        </IntlProvider>
      </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
  );
}

bootstrapApplication().catch((e) => console.error(e));

// Hot reloading
if (appConfig.isDev && module.hot != null) {
  // Reload components
  module.hot.accept();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
